var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35311 6.64663C7.39967 6.69308 7.43661 6.74825 7.46182 6.809C7.48703 6.86974 7.5 6.93486 7.5 7.00063C7.5 7.0664 7.48703 7.13152 7.46182 7.19226C7.43661 7.25301 7.39967 7.30819 7.35311 7.35463L1.3531 13.3546C1.25922 13.4485 1.13188 13.5013 0.999105 13.5013C0.866329 13.5013 0.738992 13.4485 0.645105 13.3546C0.551218 13.2607 0.498474 13.1334 0.498474 13.0006C0.498474 12.8679 0.551218 12.7405 0.645105 12.6466L6.29211 7.00063L0.645105 1.35463C0.551219 1.26074 0.498474 1.13341 0.498474 1.00063C0.498474 0.867856 0.551219 0.740518 0.645105 0.646631C0.738992 0.552745 0.86633 0.5 0.999105 0.5C1.13188 0.5 1.25922 0.552745 1.35311 0.646631L7.35311 6.64663Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLanguageIcon);
export default __webpack_public_path__ + "static/media/arrow-right-language-icon.3caf84918d7d2c0636fde663fad28399.svg";
export { ForwardRef as ReactComponent };